export default (theme) => ({
  paymentSettingsWrapper: {
    padding: '80px 80px 40px 100px',
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('xl')]: {
      padding: '60px 60px 40px 80px',
    },
    [theme.breakpoints.down('md')]: {
      padding: 60,
      height: 'calc(100% - 60px)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: 40,
      height: 'calc(100% - 40px)',
    },
  },
  addButton: {
    marginTop: 20,
  },
  noCardsText: {
    fontStyle: 'italic',
    marginTop: 35,
  },
  removeButton: {
    height: 44,
    width: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  editWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 50,
  },
  editIcon: {
    fill: '#ffffff',
    width: 16,
    height: 16,
    marginRight: 5,
  },
  cancelIcon: {
    width: 20,
    height: 20,
    fill: theme.palette.error.main,
    marginRight: 10,
  },
  stripeInfoContainer: {
    marginTop: 20,
  },
  poweredByImg: {
    width: 190,
  },
  stripeTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
  },
  stripeBox: {
    marginTop: 40,
  },
  stripeSecondaryBox: {
    marginTop: 20,
  },
  stripeLogo: {
    width: 95,
  },
  supportDocumentationLink: {
    textDecoration: 'none',
  },
  stripeDocumentation: {
    color: '#000000',
    textDecoration: 'none',
  },
});
